<template>
  <v-layout wrap justify-center align-center>
    <p-user-edit @onSave="userEdit" @close="closeUserEdit" ref="userEdit"></p-user-edit>
    <p-upgrade-dialog :upgradeDialog="upgradeDialog" @closeDialog="upgradeDialog = false" :link_src="`${basePath}images/upgrade_wpp.mp4`"></p-upgrade-dialog>
    <v-dialog class="highness" v-model="generalDialog" width="800px" :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <v-card-actions>
          <div>
            <h1>Minhas Tarefas</h1>
          </div>
          <v-tooltip top>
            <v-icon slot="activator" color="black">info</v-icon>
            <span>Veja todas as tarefas em aberto das quais você é o responsável</span>
          </v-tooltip>
          <v-btn icon style="right: 0; position: absolute" slot="activator" fab @click="close">
            <v-icon color="#444">close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text style="padding: 8px" v-if="generalDialog">
          <v-tabs dark color="cyan" v-model="tab" grow class="elevation-0" @change="changeTab">
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab key="0">
              <span v-if="!$vuetify.breakpoint.smAndDown">Tarefas Atrasadas</span>
              <span v-else>Atrasadas</span>
              <v-badge style="padding-left: 10px" class="badge" color="#039BE5" right>
                <span slot="badge">{{total_0}}</span>
              </v-badge>
            </v-tab>
            <v-tab key="1">
              <span v-if="!$vuetify.breakpoint.smAndDown">Tarefas de Hoje</span>
              <span v-else>Hoje</span>
              <v-badge style="padding-left: 10px" class="badge" color="#039BE5" right>
                <span slot="badge">{{total_1}}</span>
              </v-badge>
            </v-tab>
            <v-tab key="2">
              <span v-if="!$vuetify.breakpoint.smAndDown">Tarefas de Amanhã</span>
              <span v-else>Amanhã</span>
              <v-badge style="padding-left: 10px" class="badge" color="#039BE5" right>
                <span slot="badge">{{total_2}}</span>
              </v-badge>
            </v-tab>
            <v-tabs-items v-model="tab" touchless>
              <v-tab-item key="0">
                <v-card>
                  <v-card-text>
                    <p-user-tasks-list type="0" @moreTasks="moreTasks()" @closeUserTasks="close" :qttTasks="total_0" :items="items" :taskLoading="taskLoading"></p-user-tasks-list>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="1">
                <v-card>
                  <v-card-text>
                    <p-user-tasks-list type="1" @moreTasks="moreTasks()" @closeUserTasks="close" :qttTasks="total_1" :items="items" :taskLoading="taskLoading"></p-user-tasks-list>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="2">
                <v-card>
                  <v-card-text>
                    <p-user-tasks-list type="2" @moreTasks="moreTasks()" @closeUserTasks="close" :qttTasks="total_2" :items="items" :taskLoading="taskLoading"></p-user-tasks-list>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
          <span style="font-weight: bold">Opções de envio diario</span>
          <v-layout row justify-space-between wrap>
            <v-flex sm12 md4>
              <v-switch label="Abrir minhas tarefas" v-model="openDaily" @change="changeParams()"></v-switch>
            </v-flex>
            <v-flex sm12 md4>
              <v-layout align-center justify-center row fill-height>
                <v-flex shrink>
                  <v-switch label="Enviar por WhatsApp" v-model="dailyWpp" @change="changeParams()"></v-switch>
                </v-flex>
                <v-flex grow style="padding-bottom: 7px;">
                  <p-btn-upgrade v-if="checkIsFree()"></p-btn-upgrade>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex sm12 md4>
              <v-switch label="Enviar por E-mail" v-model="dailyEmail" @change="changeParams()"></v-switch>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>

</template>
<style scoped>
  .highness {
    max-height: 50vh;
  }
</style>
<script>
  import access from './../../mixin/access'
  import PUserEdit from './../shared/PUserEdit'
  import plan from './../../mixin/plan'
  import PUserTasksList from './../../components/shared/PUserTasksList'
  import PBtnUpgrade from './../shared/PBtnUpgrade'
  import PUpgradeDialog from './../shared/PUpgradeDialog'

  export default {
    mixins: [access, plan],
    name: 'PUserTasks',
    components: {PUserTasksList, PUserEdit, PBtnUpgrade, PUpgradeDialog},
    data () {
      return {
        generalDialog: true,
        openDaily: true,
        upgradeDialog: false,
        dailyWpp: false,
        dailyEmail: true,
        basePath: process.env.API,
        taskLoading: false,
        tab: 1,
        total_0: 0,
        total_1: 0,
        total_2: 0,
        quantity: 15,
        items: [],
        values: {}
      }
    },
    mounted () {
      Object.assign(this.values, this.$store.getters[`companyUserParams/values`])
      this.dailyEmail = this.values['dailyEmail']
      this.openDaily = this.values['openDaily']
      this.dailyWpp = this.values['dailyWpp']
      this.getTasks()
    },
    methods: {
      changeTab () {
        this.getTasks()
      },
      userEdit () {
        this.dailyWpp = true
        this.changeParams()
      },
      changeParams () {
        if (this.dailyWpp) {
          if (this.checkIsFree()) {
            // Colocado o settimeout pois não estava voltando o dailyWpp para false
            setTimeout(() => {
              this.dailyWpp = false
            }, 200)
            this.upgradeDialog = true
            return
          } else if (!this.$auth.user().phone) {
            this.$refs.userEdit.open()
            // Colocado o settimeout pois não estava voltando o dailyWpp para false
            setTimeout(() => {
              this.dailyWpp = false
            }, 200)
            return
          }
        }
        this.values = Object.assign(this.values, {dailyEmail: this.dailyEmail, openDaily: this.openDaily, dailyWpp: this.dailyWpp})
        this.$store.commit('companyUserParams/change_values', this.values)
        this.$http.post('auth/change-user-params', {'params': JSON.stringify(this.values)})
      },
      getTasks () {
        this.taskLoading = true
        this.$http.get(`api/get_user_task_list?type=${this.tab}&quantity=${this.quantity}`).then(res => {
          this.items = res.body['task']
          this.total_0 = res.body['total_0']
          this.total_1 = res.body['total_1']
          this.total_2 = res.body['total_2']
          this.taskLoading = false
        },
        err => {
          console.log(err)
          this.taskLoading = false
          this.$store.commit('snackbar/change_values', {
            text: 'Registros não foram carregados corretamente! Reporte o erro!',
            color: 'error',
            dialog: true
          })
        })
      },
      moreTasks () {
        this.quantity += 15
        this.getTasks()
      },
      close () {
        this.generalDialog = false
      },
      closeUserEdit () {
        this.dailyWpp = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PUserTasks.vue